
export interface Address {
  address: string;
  address2?: string | null;
  city: string;
  state_id: string;
  zipcode: string;
  apartment?: string | null;
  floor?: string | null;
  elevator?: string | null;
  address_type?: string;
  pickup_point?: string;
  location_lat_long?: string;
  country: string;
}

interface Document {
  doc_name: string;
  url: string;
  doc_type_id: number;
  doc_type: {
      id: string;
      user_type: string;
      doc_type: string;
      doc_name: string;
      status: string;
  };
}

interface State {
  state_name: string;
}

export interface IUserDetail {
  user_id: string;
  first_name: string;
  last_name: string;
  mobile: string;
  email: string;
  user_type: string;
  state_id: string;
  state: State;
  addresses: Address[];
  documents: Document[];
  profile_picture?: string;
  user_type_name?: string;
  sort_order?: string;
}

export enum USER_TYPE {
  Admin = "1",
  Enrollee = "2",
  TP = "4",
  Driver = "5",
  Vehicle = "6", // Its not a user type but its to handle the docs and common stuff
  Tenant = "2",
  Management = "3",
  SP = "4",
  Contractor = "5",
  Specialty = "7",
}